import { render, staticRenderFns } from "./0022.vue?vue&type=template&id=f94e4d10&scoped=true&"
import script from "./0022.vue?vue&type=script&lang=js&"
export * from "./0022.vue?vue&type=script&lang=js&"
import style0 from "./0022.vue?vue&type=style&index=0&id=f94e4d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94e4d10",
  null
  
)

export default component.exports